var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZorgverzekeringGesloten(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 178.49 202.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-3 {\n        fill: #37474f;\n      }\n\n      .cls-4 {\n        fill: #455a64;\n      }\n\n      .cls-5 {\n        opacity: .52;\n      }\n\n      .cls-6 {\n        fill: #a6a6a6;\n      }\n\n      .cls-7 {\n        fill: #b1b1b1;\n        opacity: .62;\n      }\n\n      .cls-8, .cls-9, .cls-10 {\n        opacity: .1;\n      }\n\n      .cls-8, .cls-11, .cls-12 {\n        font-family: HDColton-Bold, HDColton-Bold;\n        font-size: 17.5px;\n        font-weight: 700;\n      }\n\n      .cls-8, .cls-10 {\n        isolation: isolate;\n      }\n\n      .cls-13 {\n        letter-spacing: 0em;\n      }\n\n      .cls-14 {\n        letter-spacing: 0em;\n      }\n\n      .cls-15 {\n        fill: #767676;\n      }\n\n      .cls-16, .cls-12 {\n        fill: #ffc727;\n      }\n\n      .cls-17 {\n        letter-spacing: -.04em;\n      }\n\n      .cls-18 {\n        letter-spacing: 0em;\n      }\n\n      .cls-19 {\n        letter-spacing: -.05em;\n      }\n\n      .cls-20 {\n        letter-spacing: 0em;\n      }\n\n      .cls-21 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-22 {\n        letter-spacing: 0em;\n      }\n\n      .cls-23 {\n        fill: #263238;\n      }\n\n      .cls-24 {\n        fill: #bd4f5c;\n      }\n\n      .cls-25 {\n        fill: url(#linear-gradient);\n        filter: url(#drop-shadow-1);\n        stroke: #fff;\n        stroke-miterlimit: 10;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 165.55,
    y1: 43.49,
    x2: 122.64,
    y2: 34.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9d9d9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#c4c4c4"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-1",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--store-2--inject-65"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 4.32,
    y: 4.82,
    width: 168.26,
    height: 197.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 141.04,
    y: 23.57,
    width: 12.41,
    height: 5.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 147.96,
    y: 16.94,
    width: 12.41,
    height: 5.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 134.11,
    y: 16.94,
    width: 12.41,
    height: 5.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 23.47,
    y: 16.94,
    width: 12.41,
    height: 5.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 16.55,
    y: 159.29,
    width: 12.41,
    height: 5.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 147.96,
    y: 165.9,
    width: 12.41,
    height: 5.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 121.01,
    y: 79,
    width: 12.41,
    height: 5.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 114.09,
    y: 85.62,
    width: 12.41,
    height: 5.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    y: 65.08,
    width: 176.93,
    height: 5.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    y: 65.08,
    width: 176.93,
    height: 5.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    y: 37.18,
    width: 176.93,
    height: 5.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    y: 37.18,
    width: 176.93,
    height: 5.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4.32,
    y: 42.48,
    width: 168.26,
    height: 22.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    y: 2.18,
    width: 176.93,
    height: 5.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    y: 2.18,
    width: 176.93,
    height: 5.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    y: 196.75,
    width: 176.93,
    height: 5.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    y: 196.75,
    width: 176.93,
    height: 5.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 124.39,
    y: 74.99,
    width: 42.02,
    height: 23.79
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "166.41 74.99 166.41 86.29 153.93 98.78 139.95 98.78 163.73 74.99 166.41 74.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "150.25 74.99 126.46 98.78 124.39 98.78 124.39 97.89 147.3 74.99 150.25 74.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "139.89 74.99 124.39 90.49 124.39 84.7 134.1 74.99 139.89 74.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "166.41 90.32 166.41 96.1 163.74 98.78 157.95 98.78 166.41 90.32"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 124.39,
    y: 103.8,
    width: 42.02,
    height: 98.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 130.64,
    y: 110.22,
    width: 29.52,
    height: 48.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 130.64,
    y: 110.22,
    width: 29.52,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 130.64,
    y: 111.75,
    width: 29.52,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 130.64,
    y: 113.29,
    width: 29.52,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 130.64,
    y: 114.82,
    width: 29.52,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 130.64,
    y: 116.35,
    width: 29.52,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 130.64,
    y: 117.89,
    width: 29.52,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 130.64,
    y: 119.43,
    width: 29.52,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 130.64,
    y: 120.97,
    width: 29.52,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 130.64,
    y: 122.5,
    width: 29.52,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 130.64,
    y: 124.04,
    width: 29.52,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 130.64,
    y: 125.58,
    width: 29.52,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 130.64,
    y: 127.12,
    width: 29.52,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 130.64,
    y: 128.65,
    width: 29.52,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 130.64,
    y: 130.19,
    width: 29.52,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 130.64,
    y: 131.73,
    width: 29.52,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 130.64,
    y: 133.27,
    width: 29.52,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 130.64,
    y: 134.8,
    width: 29.52,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 130.64,
    y: 136.34,
    width: 29.52,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 130.64,
    y: 137.88,
    width: 29.52,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 130.64,
    y: 139.42,
    width: 29.52,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 130.64,
    y: 140.94,
    width: 29.52,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 130.64,
    y: 142.48,
    width: 29.52,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 130.64,
    y: 144.02,
    width: 29.52,
    height: 1.09
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "160.16 110.22 160.16 116.03 130.64 145.55 130.64 131.57 152 110.22 160.16 110.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "160.16 140.72 160.16 154.69 156.39 158.47 142.41 158.47 160.16 140.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "160.16 134.59 160.16 137.54 139.24 158.47 136.29 158.47 160.16 134.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "149.03 110.22 130.64 128.59 130.64 122.8 143.24 110.22 149.03 110.22"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 133.27,
    y: 163.92,
    width: 22.13,
    height: 5.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 161,
    y: 160.78,
    width: 2.59,
    height: 8.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m130.64,193.85c-.09-1.41-.14-2.83-.2-4.24-.06-1.41-.1-2.84-.14-4.25-.07-2.83-.13-5.66-.15-8.49v-.49h13.81c2.21,0,4.45.09,6.66.16,1.11,0,2.22.07,3.34.13s2.22.09,3.34.16l-3.34.16c-1.11,0-2.22.1-3.34.13-2.21.07-4.44.13-6.66.15-2.22.02-4.44.06-6.66.06h-6.66l.49-.49c0,2.83-.06,5.66-.14,8.49,0,1.41-.09,2.84-.15,4.25-.06,1.41-.11,2.85-.2,4.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m160.16,176.88c.09,1.41.14,2.83.2,4.25s.1,2.83.15,4.24c.07,2.84.11,5.66.15,8.49v.5h-13.96c-2.25,0-4.49-.09-6.73-.15l-3.38-.14c-1.11,0-2.24-.09-3.36-.16l3.36-.16c1.12,0,2.25-.1,3.38-.13,2.24-.07,4.49-.11,6.73-.15s4.49-.06,6.74-.06h6.73l-.49.49c0-2.83.07-5.65.15-8.49,0-1.41.07-2.83.15-4.24.07-1.41.1-2.88.19-4.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m134.46,190.65c-.15-1.76-.24-3.53-.31-5.29,0-.88-.06-1.76-.1-2.64s0-1.76,0-2.65v-.46h5.41c1.64,0,3.29,0,4.94.06,1.65.06,3.29.07,4.94.15,1.65.07,3.29.16,4.94.3-1.65.14-3.29.24-4.94.3s-3.29.13-4.94.16c-1.65.04-3.29,0-4.94,0h-4.94l.48-.48c0,.89,0,1.76-.06,2.65-.06.89,0,1.76-.09,2.64-.14,1.73-.2,3.49-.39,5.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m156.34,180.08c.15,1.76.25,3.53.31,5.29.06,1.76.13,3.53.16,5.29v.46h-10.48c-1.67,0-3.33-.09-5-.15-1.67-.06-3.33-.18-5-.31,1.67-.14,3.33-.24,5-.3,1.67-.06,3.33-.11,5-.15,1.66,0,3.33,0,5-.06,1.67-.06,3.33,0,5,0l-.46.46c0-1.77.05-3.53.15-5.29.07-1.76.17-3.48.31-5.24Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 11.49,
    y: 72.29,
    width: 104.36,
    height: 94.43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 14.09,
    y: 74.99,
    width: 99.17,
    height: 89.03
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "113.26 135.27 113.26 149.24 98.49 164.02 84.5 164.02 113.26 135.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "87.22 74.99 14.09 148.13 14.09 134.15 73.25 74.99 87.22 74.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "95.94 74.99 14.09 156.84 14.09 153.89 92.99 74.99 95.94 74.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "113.26 112.78 113.26 115.73 64.96 164.02 62.02 164.02 113.26 112.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "113.26 154.58 113.26 160.35 109.6 164.02 103.81 164.02 113.26 154.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "61.12 74.99 14.09 122.03 14.09 116.24 55.34 74.99 61.12 74.99"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 8.24,
    y: 93.28,
    width: 0.51,
    height: 36.97,
    transform: "translate(-17.23 2.67) rotate(-8.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m12.4,130.02c0,.55-.45,1-1,1s-1-.45-1-1,.45-1,1-1h0c.55,0,1,.45,1,1Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 100.22,
    y: 111.48,
    width: 36.97,
    height: 0.51,
    transform: "translate(-10.01 211.78) rotate(-81.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m114.85,130.02c0,.55.45,1,1,1s1-.45,1-1-.45-1-1-1h0c-.55,0-1,.45-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m124.65,93.13H2.72c7.3-12.65,8.75-22.75,8.75-22.75h104.43s1.43,10.1,8.75,22.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m124.65,93.13v2.69c.06,1.31-.95,2.43-2.26,2.5h-4.86c-1.32-.06-2.34-1.18-2.28-2.49,0,0,0,0,0,0,.06,1.31-.95,2.43-2.26,2.5h-4.85c-1.31-.07-2.33-1.19-2.26-2.5.06,1.31-.95,2.43-2.26,2.5h-4.85c-1.31-.07-2.33-1.19-2.26-2.5.06,1.31-.95,2.43-2.26,2.5h-4.85c-1.31-.07-2.33-1.19-2.26-2.5.06,1.32-.95,2.44-2.27,2.5,0,0,0,0,0,0h-4.84c-1.31-.07-2.33-1.19-2.26-2.5.06,1.32-.95,2.44-2.27,2.5,0,0,0,0,0,0h-4.85c-1.31-.07-2.33-1.19-2.26-2.5.06,1.31-.95,2.43-2.26,2.5h-4.85c-1.31-.07-2.33-1.19-2.26-2.5.06,1.31-.95,2.43-2.26,2.5h-4.85c-1.31-.07-2.33-1.19-2.26-2.5.06,1.31-.95,2.43-2.26,2.5h-4.85c-1.31-.07-2.33-1.19-2.26-2.5.06,1.32-.95,2.44-2.27,2.5,0,0,0,0,0,0h-4.84c-1.32-.06-2.34-1.18-2.28-2.49,0,0,0,0,0,0,.06,1.31-.95,2.43-2.26,2.5h-4.84c-1.32-.06-2.34-1.18-2.28-2.49,0,0,0,0,0,0,.06,1.31-.95,2.43-2.26,2.5h-4.84c-1.32-.06-2.34-1.18-2.28-2.49,0,0,0,0,0,0,.06,1.31-.95,2.43-2.26,2.5h-4.85c-1.31-.07-2.33-1.19-2.26-2.5v-2.69h121.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m12.15,95.82c0-.9,0-1.8-.1-2.69v-.06c1.05-1.73,1.99-3.53,2.86-5.35s1.64-3.69,2.36-5.57c.7-1.9,1.29-3.83,1.78-5.79l.35-1.47c.1-.5.16-1,.26-1.5.22-.99.28-2,.44-3-.05,2.03-.28,4.06-.69,6.05-.42,2-.98,3.96-1.67,5.88-.7,1.92-1.51,3.79-2.43,5.61-.45.91-.94,1.8-1.46,2.69s-1.04,1.75-1.62,2.57h0c-.08.84-.08,1.74-.08,2.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m21.47,95.82c0-.9,0-1.8-.1-2.69h0c.51-.85.99-1.73,1.44-2.61.45-.89.85-1.8,1.25-2.71.78-1.83,1.44-3.7,1.99-5.61.16-.47.29-.95.4-1.44.11-.48.26-.96.35-1.45.2-.97.42-1.94.56-2.92.31-1.97.52-3.95.62-5.94.07,2-.01,4-.26,5.99-.51,3.99-1.61,7.89-3.25,11.56-.81,1.84-1.79,3.59-2.92,5.25h0c0,.77-.03,1.67-.08,2.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m58.99,95.82c-.06-2.13-.06-4.24-.06-6.36s0-4.24.07-6.36c.07-2.12.1-4.24.19-6.36l.14-3.18c.06-1.06.11-2.13.19-3.18,0,1.05,0,2.11.06,3.18v3.19c0,2.11,0,4.24-.07,6.36-.07,2.12-.11,4.24-.2,6.35s-.16,4.25-.31,6.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m68.4,95.82c-.15-2.11-.24-4.24-.33-6.36-.09-2.12-.13-4.24-.19-6.35s-.07-4.25-.07-6.36v-3.19c0-1.06,0-2.13.06-3.18.07,1.05.13,2.11.19,3.18l.14,3.18c.09,2.13.14,4.24.2,6.36s0,4.24.07,6.36c.07,2.12-.07,4.24-.07,6.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m49.65,95.82c0-.9-.07-1.8-.11-2.69h0c.25-1.88.39-3.75.55-5.66.16-1.91.22-3.75.34-5.68s.15-3.75.22-5.7l.16-5.69c.06.94.1,1.89.15,2.85s0,1.9,0,2.85c0,1.9,0,3.75-.09,5.7-.09,1.95-.22,3.81-.4,5.7-.09.95-.2,1.9-.33,2.84-.13.94-.26,1.89-.45,2.83h0c-.05.85-.05,1.75-.05,2.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m40.24,95.82c0-.9-.07-1.8-.11-2.69h0c.62-1.81,1.1-3.66,1.43-5.54.18-.95.33-1.89.48-2.84s.25-1.9.36-2.85c.24-1.9.35-3.81.51-5.72l.18-2.87c0-.96.07-1.93.14-2.87,0,.95.06,1.91.09,2.87s0,1.93,0,2.89c0,1.93-.19,3.85-.39,5.76-.2,1.92-.49,3.83-.89,5.72-.19.94-.42,1.88-.7,2.8-.26.94-.58,1.85-.97,2.74h0c-.05.8-.08,1.7-.11,2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m30.9,95.82c0-.9,0-1.8-.1-2.69v-.06c.84-1.75,1.55-3.56,2.1-5.42.59-1.86,1.01-3.75,1.41-5.66.4-1.91.65-3.84.88-5.77.14-.96.16-1.94.28-2.9.11-.96.1-1.95.18-2.92v4.4c0,.49,0,.97-.09,1.46l-.11,1.46c0,.5-.13.97-.19,1.46-.11.97-.29,1.94-.45,2.91-.37,1.93-.87,3.83-1.47,5.7-.3.94-.65,1.85-1.04,2.75-.36.91-.77,1.8-1.25,2.65h0c-.14.84-.14,1.74-.14,2.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m115.25,95.82c0-.9-.06-1.8-.1-2.69h0c-.59-.83-1.11-1.7-1.62-2.57s-1.01-1.78-1.46-2.69c-.91-1.81-1.71-3.66-2.41-5.56-.7-1.91-1.25-3.88-1.66-5.88-.42-1.99-.65-4.02-.69-6.05.15,1,.21,2.01.42,3,.1.5.16,1,.28,1.5l.34,1.47c.48,1.96,1.08,3.89,1.79,5.79.71,1.89,1.46,3.75,2.35,5.57s1.81,3.62,2.86,5.35v.06c-.01.89-.04,1.79-.09,2.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m105.9,95.82c0-.9-.07-1.8-.1-2.69h0c-1.13-1.66-2.11-3.41-2.92-5.25-.83-1.83-1.51-3.73-2.05-5.66-.57-1.93-.99-3.9-1.25-5.9-.25-1.99-.34-3.99-.26-5.99.11,1.99.32,3.97.62,5.94.15.99.37,1.95.56,2.92.1.49.24.97.35,1.45s.25.96.4,1.44c.54,1.91,1.21,3.79,1.99,5.61.4.91.8,1.82,1.25,2.71s.94,1.76,1.45,2.61v.06c-.04.94-.04,1.84-.04,2.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m77.75,95.82c0-.9-.07-1.8-.11-2.69h0c-.19-.94-.31-1.88-.45-2.83s-.24-1.89-.33-2.84c-.16-1.89-.33-3.75-.39-5.7-.06-1.95-.14-3.75-.1-5.7,0-.95,0-1.9.06-2.85.06-.95.07-1.91.14-2.85l.16,5.69c.07,1.9.13,3.75.22,5.7s.19,3.75.35,5.68c.16,1.93.29,3.75.54,5.66h0c-.04.92-.05,1.82-.1,2.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m87.15,95.82c0-.9-.07-1.8-.11-2.69h0c-.39-.89-.72-1.8-.97-2.74-.26-.92-.5-1.86-.7-2.8-.39-1.89-.68-3.8-.88-5.72-.21-1.91-.35-3.84-.4-5.76v-2.89c0-.96,0-1.93.09-2.87.06.95.1,1.91.15,2.87l.16,2.87c.16,1.91.28,3.82.53,5.72.1.95.24,1.9.36,2.85.13.95.29,1.89.48,2.84.32,1.88.79,3.73,1.41,5.54h0c-.11.97-.11,1.88-.11,2.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m96.5,95.82c0-.9-.07-1.8-.1-2.69h0c-.48-.85-.89-1.74-1.25-2.65-.4-.9-.74-1.82-1.04-2.75-.61-1.87-1.11-3.77-1.47-5.7-.16-.97-.35-1.94-.46-2.91-.06-.49-.14-.96-.18-1.46l-.13-1.46c0-.48-.02-.97-.07-1.46v-4.4c.07.97.11,1.95.19,2.92.07.97.14,1.94.26,2.9.22,1.94.5,3.88.88,5.77.38,1.9.84,3.75,1.43,5.66.54,1.86,1.24,3.68,2.09,5.42v.06c-.06.94-.09,1.84-.14,2.74Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12,189.54c-.1-1.43-.14-2.84-.2-4.25-.06-1.41-.1-2.83-.15-4.25-.07-2.83-.11-5.66-.15-8.49v-.49h13.82c2.22,0,4.44.09,6.66.16,1.11,0,2.22.09,3.33.13l3.34.16c-1.11.07-2.22.11-3.34.16-1.11.05-2.21.1-3.33.13-2.22.07-4.45.13-6.66.16s-4.45,0-6.66,0h-6.66l.49-.49c0,2.83-.07,5.66-.15,8.49,0,1.43-.07,2.84-.15,4.25s-.04,2.9-.19,4.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41.53,172.55c.09,1.41.14,2.83.2,4.25s.1,2.83.14,4.24c.07,2.84.11,5.66.15,8.5v.49h-7.23c-2.25,0-4.49,0-6.73-.06s-4.49-.07-6.74-.15l-3.36-.14-3.38-.15c1.12-.07,2.25-.13,3.38-.16l3.36-.14c2.25-.07,4.49-.11,6.74-.15,2.25-.04,4.49-.06,6.73-.06h6.74l-.49.5c0-2.84.06-5.66.14-8.5,0-1.41.09-2.83.15-4.24s.11-2.81.2-4.23Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m15.83,186.33c-.07-1.76-.14-3.53-.16-5.29v-5.51h10.11c1.64,0,3.29,0,4.93.07,1.64.07,3.3.09,5,.15-1.64.06-3.29.13-5,.15-1.71.02-3.29.07-4.93.07h-9.88l.22-.22v5.29c-.22,1.76-.22,3.53-.3,5.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.7,175.75c.06,1.76.13,3.53.15,5.29.02,1.76.07,3.53.07,5.29v.22h-10.22c-1.66,0-3.33,0-5-.07-1.67-.07-3.33-.07-5-.15,1.66-.06,3.33-.11,5-.14,1.67-.02,3.33-.09,5-.09h10l-.24.22c0-1.76,0-3.53.07-5.29.07-1.76.09-3.53.16-5.29Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m52.74,186.33c-.06-1.76-.13-3.53-.15-5.29v-5.51h10.1c1.65,0,3.29,0,4.94.07l4.94.15c-1.65.06-3.3.13-4.94.15-1.64.02-3.29.07-4.94.07h-9.88l.22-.22v5.29c-.17,1.76-.24,3.53-.3,5.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m74.65,175.75c0,1.76.13,3.53.15,5.29s.07,3.53.07,5.29v.22h-10.22c-1.66,0-3.33,0-5-.07-1.67-.07-3.33-.07-5-.15,1.66-.06,3.33-.11,5-.14,1.67-.02,3.33-.09,5-.09h10l-.22.22c0-1.76,0-3.53.07-5.29.07-1.76.05-3.53.15-5.29Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m48.91,189.54c-.09-1.43-.14-2.84-.2-4.25-.06-1.41-.1-2.83-.14-4.25-.07-2.83-.13-5.66-.15-8.49v-.49h13.82c2.21,0,4.45.09,6.66.16,1.11,0,2.22.09,3.34.13l3.33.16c-1.1.07-2.21.11-3.33.16s-2.22.1-3.34.13c-2.21.07-4.44.13-6.66.16s-4.44,0-6.66,0h-6.66l.49-.49c0,2.83-.07,5.66-.14,8.49,0,1.43-.09,2.84-.15,4.25s-.13,2.9-.21,4.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m78.4,172.55c.09,1.41.14,2.83.2,4.25s.1,2.83.15,4.24c.07,2.84.11,5.66.15,8.5v.49h-7.22c-2.24,0-4.49,0-6.74-.06s-4.49-.07-6.73-.15l-3.38-.14c-1.12,0-2.24-.09-3.36-.15,1.12-.07,2.24-.13,3.36-.16l3.38-.14c2.24-.07,4.49-.11,6.73-.15,2.24-.04,4.49-.06,6.74-.06h6.73l-.49.5c0-2.84.07-5.66.15-8.5,0-1.41.07-2.83.14-4.24s.2-2.81.2-4.23Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m89.65,186.33c-.06-1.76-.13-3.53-.15-5.29v-5.51h10.03c1.65,0,3.29,0,5,.07,1.71.07,3.29.09,4.94.15-1.65.06-3.29.13-4.94.15-1.65.02-3.29.07-5,.07l-4.88.07h-4.94l.24-.22v5.29c-.17,1.69-.22,3.45-.3,5.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m111.53,175.75c.07,1.76.13,3.53.16,5.29.04,1.76.06,3.53.07,5.29v.22h-10.24c-1.66,0-3.33,0-5-.07-1.67-.07-3.33-.07-5-.15,1.66-.06,3.33-.11,5-.14,1.67-.02,3.33-.09,5-.09h10l-.22.22c0-1.76,0-3.53.07-5.29.07-1.76.09-3.53.15-5.29Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m85.9,189.54c-.09-1.43-.14-2.84-.2-4.25-.06-1.41-.1-2.83-.15-4.25-.07-2.83-.11-5.66-.15-8.49v-.49h13.82c2.22,0,4.44.09,6.66.16,1.11,0,2.22.09,3.33.13l3.34.16c-1.11.07-2.22.11-3.34.16-1.11.05-2.21.1-3.33.13-2.22.07-4.44.13-6.66.16s-4.45,0-6.66,0h-6.66l.49-.49c0,2.83-.07,5.66-.15,8.49,0,1.43-.07,2.84-.14,4.25-.06,1.41-.2,2.9-.2,4.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m115.36,172.55c.09,1.41.14,2.83.2,4.25.06,1.42.1,2.83.14,4.24.07,2.84.13,5.66.15,8.5v.49h-7.23c-2.25,0-4.49,0-6.73-.06s-4.49-.07-6.74-.15l-3.36-.14-3.38-.15c1.12-.07,2.25-.13,3.38-.16l3.36-.14c2.25-.07,4.49-.11,6.74-.15,2.25-.04,4.49-.06,6.73-.06h6.74l-.49.5c0-2.84.06-5.66.14-8.5,0-1.41.09-2.83.15-4.24.06-1.41.11-2.81.2-4.23Z"
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-12",
    transform: "translate(17.7 58.96)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-2",
    x: 0,
    y: 0
  }, "z"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-20",
    x: 9.4,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-21",
    x: 20.68,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 27.23,
    y: 0
  }, "g"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 38.93,
    y: 0
  }, "v"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-22",
    x: 49.73,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-18",
    x: 61.01,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-2",
    x: 67.91,
    y: 0
  }, "z"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-13",
    x: 77.31,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 88.68,
    y: 0
  }, "k"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-22",
    x: 98.1,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-18",
    x: 109.38,
    y: 0
  }, "ri"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-14",
    x: 121.12,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    x: 132.38,
    y: 0
  }, "g")), /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(17.7 58.96)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-2",
    x: 0,
    y: 0
  }, "z"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-20",
    x: 9.4,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-21",
    x: 20.68,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 27.23,
    y: 0
  }, "g"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 38.93,
    y: 0
  }, "v"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-22",
    x: 49.73,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-18",
    x: 61.01,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-2",
    x: 67.91,
    y: 0
  }, "z"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-13",
    x: 77.31,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 88.68,
    y: 0
  }, "k"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-22",
    x: 98.1,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-18",
    x: 109.38,
    y: 0
  }, "ri"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-14",
    x: 121.12,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    x: 132.38,
    y: 0
  }, "g"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 33.41,
    y: 110.62,
    width: 60.51,
    height: 34.58
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "m41.5,132.72c-.85.04-1.6-.21-2.23-.75-.65-.55-.99-1.25-1.03-2.1-.05-1.09.53-2.02,1.75-2.78.45-.28,1.07-.52,1.84-.71.22-.06.35-.08.38-.09.31-.02.62.05.91.21.29.15.51.36.66.63.09.1.14.19.15.28,0,.11-.03.2-.12.27-.08.07-.18.11-.28.12-.11,0-.19-.03-.27-.11-.48-.17-.95-.24-1.4-.22-.72.04-1.35.31-1.87.81-.54.52-.79,1.14-.76,1.85.02.47.2.83.53,1.07.31.22.7.33,1.18.3.66-.03,1.46-.3,2.39-.79h0c.09-.06.18-.16.26-.29.08-.13.12-.25.12-.35,0-.21-.22-.3-.64-.28-.29.01-.6.09-.96.23-.12.05-.43.17-.92.38-.13.06-.24.09-.33.09-.21.01-.33-.13-.34-.42,0-.15.08-.3.27-.43.71-.54,1.32-.82,1.83-.84.55-.03,1.02.09,1.4.37.43.29.65.7.68,1.24.03.64-.35,1.2-1.14,1.66-.67.39-1.35.61-2.05.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "m50.65,130.6c.02.33-.09.56-.31.69-.35.19-.93.4-1.74.61-.71.19-1.33.31-1.85.39-.1.09-.22.14-.38.15-.16,0-.31-.03-.45-.1-.15-.09-.23-.21-.24-.37v-.04c-.02-.33-.03-.83-.02-1.5s0-.95.01-.87c-.03-.65-.09-1.33-.17-2.06-.07.03-.13.05-.19.05-.2,0-.31-.1-.32-.32-.02-.36.23-.62.75-.8,1.21-.4,2.35-.63,3.42-.68.18,0,.33.05.45.17.11.12.18.28.19.48.01.25-.07.37-.24.38-.02,0-.06,0-.14-.02-.16-.02-.51-.01-1.04.01-.61.03-1.25.16-1.9.37.04.32.1.8.17,1.43.91-.08,1.55-.27,1.93-.55.09-.07.16-.11.21-.11.12,0,.23.06.33.21.09.13.13.26.14.4,0,.17-.06.3-.2.38-.4.21-1.17.42-2.3.63.03.32.07.79.12,1.41.71-.04,1.26-.09,1.66-.17.63-.13,1.13-.34,1.5-.63.1-.08.18-.13.23-.13.11,0,.21.06.28.21.06.12.09.24.1.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "m56.85,129.71c.03.68-.29,1.27-.98,1.75-.6.43-1.27.66-1.99.7-.71.04-1.37-.1-1.97-.41-.26-.13-.4-.29-.41-.46,0-.16.04-.3.16-.43.11-.13.24-.19.4-.2.09,0,.21.01.35.05.73.22,1.32.32,1.76.29.33-.02.67-.09.99-.22.43-.18.64-.4.63-.67-.01-.28-.29-.55-.84-.81-.43-.21-1-.36-1.7-.43-.14-.01-.73-.05-1.78-.1-.29-.02-.44-.17-.45-.47-.02-.36.1-.76.35-1.19.21-.36.47-.69.8-.98.19-.17.34-.29.46-.37.18-.11.36-.17.55-.18.4-.02.73.04.99.18.24.13.49.36.73.69.13.17.2.31.21.42,0,.09-.03.18-.11.27s-.16.13-.25.13c-.13,0-.27-.06-.42-.19-.64-.31-1.04-.46-1.2-.45-.19,0-.4.14-.6.38s-.3.47-.29.66c0,.13.07.21.18.23.06.01.16.02.27.02.96-.02,1.72.04,2.28.19,1.2.32,1.82.85,1.86,1.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "m62.54,130.51c0,.19-.09.29-.29.3-.08,0-.21,0-.37,0-.16,0-.29,0-.37,0-.44.02-.85.08-1.23.19-.49.14-.8.23-.92.26-.06.02-.3.12-.71.3-.34.14-.56.22-.66.22-.46.02-.69-.12-.71-.42v-.06c-.04-.68-.05-1.35-.05-1.99v-.89c-.04-.62-.08-1.17-.12-1.62,0-.02-.02-.17-.06-.46-.02-.19-.04-.34-.05-.46,0-.16.05-.3.16-.42.11-.12.25-.18.41-.19.21-.01.34.1.41.34.1.42.23,1.26.39,2.52l.27,2.22c.84-.34,1.69-.53,2.56-.57.41-.02.71,0,.88.05.3.09.46.31.48.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "m65.7,131.56c-.79.04-1.48-.24-2.06-.84-.56-.58-.87-1.27-.91-2.06-.05-.94.26-1.76.91-2.46.66-.68,1.46-1.05,2.4-1.1.9-.04,1.64.23,2.21.82.56.57.86,1.31.91,2.21.05.99-.44,1.86-1.46,2.6-.71.52-1.38.79-2,.82Zm.44-5.14c-.68.03-1.31.32-1.9.85-.38.33-.55.75-.53,1.26.02.41.23.76.62,1.06.37.29.77.43,1.19.41.29-.01.64-.11,1.04-.28.4-.17.71-.35.91-.55.25-.24.41-.4.48-.5.17-.21.24-.42.23-.63-.03-.56-.24-.99-.64-1.27-.36-.26-.83-.38-1.41-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "m75.09,125.64c-.09,0-.22,0-.4,0-.18,0-.31,0-.4,0-.42.02-.83.08-1.25.17.26,2.02.4,3.39.44,4.12.02.36,0,.61-.02.74-.07.27-.24.42-.51.43-.17,0-.31-.03-.45-.13-.15-.09-.23-.22-.24-.37v-.03c-.03-.55-.04-1.01-.05-1.38,0-.19,0-.47,0-.83v-.29c-.03-.65-.08-1.31-.14-1.97-.74.26-1.36.5-1.83.74-.1.05-.18.08-.23.08-.08,0-.15-.05-.2-.15-.04-.08-.07-.17-.07-.27-.01-.21.06-.36.2-.47.06-.04.29-.17.69-.38,1.53-.79,2.7-1.21,3.52-1.25.27-.01.47,0,.59.02.19.04.35.13.48.28.13.15.2.33.21.52.01.27-.1.42-.34.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "m81.47,129.07c.02.33-.09.56-.31.69-.35.19-.93.4-1.74.61-.71.19-1.33.31-1.85.39-.1.09-.22.14-.38.15-.16,0-.31-.03-.45-.1-.15-.09-.23-.21-.24-.37v-.04c-.02-.33-.03-.83-.02-1.5,0-.66,0-.95.01-.87-.03-.65-.09-1.33-.17-2.06-.07.03-.13.05-.19.05-.2,0-.3-.1-.32-.32-.02-.36.23-.62.75-.8,1.21-.4,2.35-.63,3.42-.68.19,0,.33.05.45.17.11.12.18.28.19.47.01.25-.07.37-.24.38-.02,0-.06,0-.14-.02-.16-.02-.51-.01-1.04.01-.61.03-1.25.16-1.9.37.04.32.1.8.17,1.43.91-.08,1.55-.26,1.93-.55.09-.07.16-.11.21-.11.12,0,.23.06.33.21.09.13.13.26.14.4,0,.17-.06.3-.2.38-.4.21-1.17.42-2.3.63.03.32.07.79.12,1.41.71-.04,1.26-.09,1.66-.17.63-.13,1.13-.34,1.5-.63.1-.09.18-.13.23-.13.11,0,.21.06.28.21.06.12.09.24.1.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "m87.13,130.78c-.33.02-.56-.06-.7-.23-1.13-.56-2.24-1.78-3.31-3.67.14,1.2.22,2.1.25,2.68.01.3,0,.51-.04.64-.07.21-.24.33-.49.34-.17,0-.33-.03-.46-.11-.15-.09-.24-.21-.24-.38,0-.06,0-.19,0-.38v-.38c.02-.32,0-.83-.03-1.54-.04-.7-.07-1.22-.11-1.57,0-.06-.03-.19-.06-.4-.02-.16-.04-.3-.04-.4,0-.17.06-.3.2-.4.12-.09.26-.14.43-.15.12,0,.23.08.33.25.05.09.22.32.5.7.61.82,1.05,1.39,1.33,1.71.56.64,1.11,1.1,1.63,1.38,0-.43-.02-.86-.04-1.29,0,.17,0,.07-.05-.33-.04-.34-.07-.64-.09-.88-.03-.39-.07-.89-.1-1.48v-.04c0-.15.04-.29.16-.4s.25-.17.4-.18c.21-.01.35.1.41.34l.74,5.35c.03.52-.19.79-.66.81Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m90.75,141.89h-54.14v-28h54.14v28Zm-54.01-.13h53.88v-27.74h-53.88v27.74Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-11",
    transform: "translate(17.7 58.96)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-2",
    x: 0,
    y: 0
  }, "z"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-20",
    x: 9.4,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-21",
    x: 20.68,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 27.23,
    y: 0
  }, "g"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 38.93,
    y: 0
  }, "v"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-22",
    x: 49.73,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-18",
    x: 61.01,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-2",
    x: 67.91,
    y: 0
  }, "z"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-13",
    x: 77.31,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 88.68,
    y: 0
  }, "k"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-22",
    x: 98.1,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-18",
    x: 109.38,
    y: 0
  }, "ri"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-14",
    x: 121.12,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    x: 132.38,
    y: 0
  }, "g")), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m176.93,7.48V2.18H0v5.3h4.32v29.7H0v5.3h4.32v22.6H0v5.3h4.32v19.83c-.5.96-1.03,1.93-1.6,2.92h0v2.69c-.05,1.08.63,2.02,1.6,2.36v98.58H0v5.3h176.93v-5.3h-4.34v-126.38h4.34v-5.3h-4.34v-22.6h4.34v-5.3h-4.34V7.48h4.34Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m26.82,51.7l-4.58,4.91h4.58v2.35h-8.57v-2.35l4.57-4.91h-4.57v-2.35h8.57v2.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.65,54.16c0-3.24,2.06-4.97,5.18-4.97s5.15,1.72,5.15,4.97-2.06,4.97-5.15,4.97-5.18-1.72-5.18-4.97Zm5.18,2.61c1.18,0,2.03-.9,2.03-2.61,0-1.7-.85-2.61-2.03-2.61s-2.05.91-2.05,2.61.85,2.61,2.05,2.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.3,53.89v5.07h-3.13v-9.62h3.13v1.26c.57-.95,1.53-1.42,2.77-1.42v2.4c-1.87-.09-2.77.95-2.77,2.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.82,49.35v8.4c0,3.28-2.28,4.81-5.09,4.81-2.64,0-4.7-1.47-4.97-3.93h3.12c.21,1.1.89,1.61,1.84,1.61,1.2,0,1.97-.8,1.97-2.55v-.95c-.62.96-1.6,1.41-2.91,1.41-2.48,0-4.31-1.77-4.31-4.36s1.79-4.58,4.28-4.58c1.29,0,2.3.45,2.95,1.45v-1.3h3.12Zm-5.19,6.52c1.21,0,1.99-.89,1.99-2.09s-.79-2.15-1.99-2.15-2.04.86-2.04,2.13.79,2.11,2.04,2.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.28,49.35l2.06,6.44,2.06-6.44h3.46l-3.68,9.62h-3.68l-3.68-9.62h3.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m77.81,51.83c.38.84.55,1.84.49,2.96h-7.16c.18,1.31.97,2.02,2.02,2.02.86,0,1.59-.45,1.84-1.42h3.11c-.38,2.46-2.4,3.73-4.95,3.73-3.11,0-5.18-1.73-5.18-4.97s2.07-4.97,5.19-4.97c2.27,0,3.89,1,4.64,2.64Zm-2.74,1.29c-.03-.16-.06-.3-.1-.44-.29-.81-.94-1.24-1.8-1.24-.98,0-1.69.59-1.96,1.68h3.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m82.64,53.89v5.07h-3.13v-9.62h3.13v1.26c.57-.95,1.53-1.42,2.77-1.42v2.4c-1.87-.09-2.77.95-2.77,2.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m94.73,51.7l-4.58,4.91h4.58v2.35h-8.57v-2.35l4.57-4.91h-4.57v-2.35h8.57v2.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m105.39,51.83c.38.84.55,1.84.49,2.96h-7.16c.18,1.31.97,2.02,2.02,2.02.86,0,1.59-.45,1.84-1.42h3.11c-.38,2.46-2.4,3.73-4.95,3.73-3.11,0-5.18-1.73-5.18-4.97s2.07-4.97,5.19-4.97c2.27,0,3.89,1,4.64,2.64Zm-2.74,1.29c-.03-.16-.06-.3-.1-.44-.29-.81-.94-1.24-1.8-1.24-.98,0-1.69.59-1.96,1.68h3.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m110.31,52.66l2.57-3.31h3.59l-3.79,4.81,3.83,4.81h-3.59l-2.61-3.29v3.29h-3.13v-12.79h3.13v6.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m126.18,51.83c.38.84.55,1.84.49,2.96h-7.16c.18,1.31.97,2.02,2.02,2.02.86,0,1.59-.45,1.84-1.42h3.11c-.38,2.46-2.4,3.73-4.95,3.73-3.11,0-5.18-1.73-5.18-4.97s2.07-4.97,5.19-4.97c2.27,0,3.89,1,4.64,2.64Zm-2.74,1.29c-.03-.16-.06-.3-.1-.44-.29-.81-.94-1.24-1.8-1.24-.98,0-1.69.59-1.96,1.68h3.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m131.01,53.89v5.07h-3.13v-9.62h3.13v1.26c.57-.95,1.53-1.42,2.77-1.42v2.4c-1.87-.09-2.77.95-2.77,2.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m136.4,45.18c1.1,0,1.83.7,1.83,1.55s-.73,1.56-1.83,1.56-1.84-.7-1.84-1.56.73-1.55,1.84-1.55Zm1.56,13.78h-3.12v-9.62h3.12v9.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m145.75,51.96c-.27-.28-.67-.43-1.18-.43-1.08,0-1.83.86-1.83,2v5.43h-3.13v-9.62h3.13v1.34c.5-.95,1.5-1.5,2.79-1.5s2.16.32,2.78.94c.7.66,1.03,1.67,1.03,2.99v5.85h-3.13v-5.53c0-.66-.15-1.15-.46-1.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m160.97,49.35v8.4c0,3.28-2.28,4.81-5.09,4.81-2.64,0-4.7-1.47-4.97-3.93h3.12c.21,1.1.89,1.61,1.84,1.61,1.2,0,1.97-.8,1.97-2.55v-.95c-.62.96-1.6,1.41-2.91,1.41-2.48,0-4.31-1.77-4.31-4.36s1.79-4.58,4.28-4.58c1.29,0,2.3.45,2.95,1.45v-1.3h3.12Zm-5.19,6.52c1.21,0,1.99-.89,1.99-2.09s-.79-2.15-1.99-2.15-2.04.86-2.04,2.13.79,2.11,2.04,2.11Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m163.39,32.26l.4-2.58c.1-.71.16-1.41.19-2.11l.05-.49h-.05c.11-9.03-6.37-16.87-15.49-18.28-9.11-1.41-17.66,4.1-20.27,12.74h-.04s-.1.47-.1.47c-.2.68-.36,1.37-.46,2.08l-.4,2.58c-2.86-.44-5.53,1.53-5.97,4.37l-4.39,28.43c-.44,2.84,1.52,5.52,4.37,5.96l36.18,5.59c2.86.45,5.52-1.53,5.96-4.36l4.39-28.43c.44-2.85-1.52-5.52-4.36-5.97Zm-15.08,16.78c-.3,1.21-1.51,2.62-4.01,3.6-.27.11-.46.38-.45.68.17,2.73.26,4.6-.09,7.3-.05.37-.41.63-.78.58l-5.41-.84c-.38-.06-.63-.42-.58-.78.47-2.69,1.07-4.47,2.04-7.04.09-.26.03-.56-.18-.75-1.88-1.73-2.51-3.35-2.35-4.56.94-7.17,13.5-5.06,11.81,1.82Zm7.72-20.56l-.4,2.58-20.67-3.19.4-2.58c.1-.72.32-1.41.58-2.06.35-.93.83-1.77,1.39-2.54.18-.23.33-.46.53-.68.19-.22.4-.42.62-.64.26-.24.51-.48.8-.69.19-.16.4-.29.61-.43.33-.24.68-.45,1.05-.64.2-.09.4-.2.6-.29.4-.18.82-.31,1.23-.44.2-.05.39-.13.59-.18.45-.09.91-.15,1.38-.2.19-.02.38-.05.56-.06.66-.03,1.34,0,2.01.1.71.1,1.4.29,2.05.53,3.25,1.2,5.67,3.97,6.51,7.27.16.65.26,1.32.3,2.01.02.69-.01,1.41-.13,2.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m148.3,49.03c-.3,1.21-1.51,2.62-4.01,3.6-.27.11-.46.38-.45.68.17,2.73.26,4.6-.09,7.3-.05.37-.41.63-.78.58l-5.41-.84c-.38-.06-.63-.42-.58-.78.47-2.69,1.07-4.47,2.04-7.04.09-.26.03-.56-.18-.75-1.88-1.73-2.51-3.35-2.35-4.56.94-7.17,13.5-5.06,11.81,1.82Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZorgverzekeringGesloten);
export default __webpack_public_path__ + "static/media/zorgverzekering-gesloten.50b3ebe52b193d4f79258ae2f13a62db.svg";
export { ForwardRef as ReactComponent };